import { render, staticRenderFns } from "./TeamsAddEdit.vue?vue&type=template&id=bbc9de8e&"
import script from "./TeamsAddEdit.vue?vue&type=script&lang=ts&"
export * from "./TeamsAddEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports